import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CloseSideContextMenuAction, ContextMenuData } from '../../../../Redux/Actions/Atlas/contextSideMenu.action';

import './ContextMenu.style.scss';
import { RootState } from '../../../../Redux/Store/store';
import { DeleteAnimationAction } from '../../../../Redux/Actions/Animator/animation.list.action';
import { ObserverAnim, GLOBAL_EVENT_ANIM } from '../../Observer';
import { DeleteFrameAction } from '../../../../Redux/Actions/Animator/frames.list.action';

let cambio = true;

const ContextMenu = (props: any) => {
    
    const sideMenuContext: ContextMenuData = useSelector((state: RootState) => state.contextSideMenuAtlas);
    const dispatch = useDispatch();
    
    let fadeIn = (cambio) ? 'fadeIn' : 'fadeIn2';
    let contextMenuClassName = `context-menu animated ${(sideMenuContext.active) ? 'active ' + (cambio = !cambio, fadeIn) : ''}`;
    
    const is_frames_secction = (sideMenuContext.options !== undefined && sideMenuContext.options.value === 'frames');
    // Colocamos la posición, en el top se corrige 

    const positionXYMenu = {
        top: ((sideMenuContext.y + 80) > globalThis.innerHeight) ? `${sideMenuContext.y - 100}px` : `${sideMenuContext.y}px`,
        left: ((sideMenuContext.x + 200) > globalThis.innerWidth) ? `${sideMenuContext.x - 200}px` : `${sideMenuContext.x}px` 
    };

    const handleClickChangeName = () => {
        ObserverAnim.emit(GLOBAL_EVENT_ANIM.EDIT_ANIM_NAME, sideMenuContext.id);
        closeMenu();
    }

    const handleClickDelete = () => {
        if (is_frames_secction) {
            dispatch(DeleteFrameAction({ local_id: sideMenuContext.id }));
        } else {
            dispatch(DeleteAnimationAction({ id: sideMenuContext.id }));
        }
        closeMenu();
    }

    const closeMenu = () => {
        dispatch(CloseSideContextMenuAction());
    }

    return (
        <div className={contextMenuClassName} style={positionXYMenu} onContextMenu={(e) => { e.preventDefault() }}>
            {
                !is_frames_secction &&
                <div className="options" onClick={handleClickChangeName}>
                    Change Name
                </div>
            }
            <div className="options" onClick={handleClickDelete}>
                Delete {is_frames_secction ? 'frame' : 'animation'}
            </div>
        </div>
    )
}

export default ContextMenu
